import type {MaterialStoragesHistory, HistoryMaterialStorage} from '@domain/material-storage'
import {Moment} from 'moment-timezone'

import {getRelevantHistoryEntry} from './history'

export const getStoragesFromHistory = (
  history: MaterialStoragesHistory,
  date: Moment
): HistoryMaterialStorage[] => {
  return Object.values(history)
    .map((storageHistory) => getRelevantHistoryEntry(storageHistory, date))
    .filter((entry): entry is HistoryMaterialStorage => Boolean(entry))
}

export const toRecord = <T extends Record<string, unknown>>(
  array: T[],
  key: keyof T
): Record<string, T> => {
  return array.reduce(
    (acc, item) => {
      acc[String(item[key])] = item
      return acc
    },
    {} as Record<string, T>
  )
}
